/* eslint-disable react/prop-types */
import React from 'react';
import { useSelector } from 'react-redux';
import DepartmentsContainerHeader from '@/views/pages/Departments/elements/DepartmentsContainerHeader';
import DepartmentsItem from '@/views/pages/Departments/elements/DepartmentsItem';
import Spinner from '@/views/components/Spinner/Spinner';

const DepartmentsContainer = ({ 
	depData,
	isLoading, 
	onEditItem,
	onDeleteItem,
	setShowModalDeleteItem,
	setShowModalAddDepartment,
	setShowModalHeaderFooter,
}) => {
	const { dict } = useSelector((state) => state.app);

	return (
		<section className='table__container'>
			<DepartmentsContainerHeader />
			{ depData && !isLoading && depData.map((item) => {
				return (
					<DepartmentsItem
						key={ item.id }
						data={ item }
						onEditItem={ onEditItem }
						onDeleteItem={ onDeleteItem }
						setShowModalDeleteItem={ setShowModalDeleteItem }
						setShowModalAddDepartment={ setShowModalAddDepartment }
						setShowModalHeaderFooter={ setShowModalHeaderFooter }
					/>
				);

			})}
			{ (!depData || isLoading) && (
				<Spinner addClass='table__spinner' />
			)}
			{ depData && depData.length === 0 && (
				<div className='table__no-elements'>
					{ dict.departments.list.noElements}
				</div>
			)}
		</section>
	);
};
export default DepartmentsContainer;